import React from "react";

export const StepSubTitle = ({children, style}) => (
    <div
        style={{
            fontSize: 20,
            color: "var(--secondary-color)",
            fontWeight: 500,
            lineHeight: "30px",
            marginTop: 20,
            marginLeft: 20,
            marginRight: 20,
            textAlign: "center",
            ...style
        }}>
        {children}
    </div>
);
